import PropTypes from 'prop-types';
import { useLocation, Navigate, Outlet } from 'react-router-dom';

import OverLayLoader from '../../OverLayLoader';
import { useAuth, authStatus } from '../../../context/auth/AuthContext';

export default function PublicRoute({ redirectTo, children }) {
  const { status } = useAuth();

  const location = useLocation();
  const fromPage = location.state?.from?.pathname || redirectTo;

  if (status === authStatus.LOADING) {
    return <OverLayLoader />;
  }

  if (status === authStatus.AUTHENTICATED) {
    return <Navigate to={fromPage} state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
}

PublicRoute.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.node,
};
